require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-how-long-until-i-reach-my-savings-goal.json") })
        }
      }, "path---calculators-how-long-until-i-reach-my-savings-goal");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-how-long-until-i-reach-my-savings-goal!./.cache/json/calculators-how-long-until-i-reach-my-savings-goal.json
// module id = 1959
// module chunks = 231608221292675